import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from './../layout/Dashboard';
import { FormattedMessage } from 'react-intl';
import { Messages } from "../../components/layout/Messages/Messages";
import {
  NOTIFICATION_CREATE_COUPON,
  NOTIFICATION_ORDER_ACTIONS
} from '../../config/notifications';
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { EditCampaignForm } from "../../components/pages/campaignManagement/editCampaign/EditCampaignForm";
import { CouponTable } from "../../components/pages/campaignManagement/CouponTable";
import { AddCouponInCampaign } from "../../components/pages/campaignManagement/editCampaign/actionButtons/AddCoupoinInCampaign";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './EditCampaign.scss';

function EditCampaignComponent(props) {
  const [ couponCreated, setCouponCreated ] = useState(false);
  const [ campaign, setCampaign ] = useState(false);

  const hasCouponCreateAccess = () => {
    return hasCampaignsEditAccess && ACL.CLIENT.COUPONS.LIST.hasAccess() && ACL.CLIENT.COUPONS.SEARCH.hasAccess() && ACL.CLIENT.COUPONS.CREATE.hasAccess();
  };

  const hasCouponListAccess = () => {
    return ACL.CLIENT.COUPONS.LIST.hasAccess() && ACL.CLIENT.COUPONS.SEARCH.hasAccess() && moment(campaign.end_date).isSameOrAfter(moment(), 'day');
  };

  const hasCampaignsEditAccess = () => {
    return ACL.CLIENT.CAMPAIGNS.CREATE.hasAccess() && ACL.CLIENT.CAMPAIGNS.LIST.hasAccess() && ACL.CLIENT.CAMPAIGNS.SEARCH.hasAccess();
  };

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="campaign-detail-workspace">
        <PageHeader title={<FormattedMessage id="components.pages.campaignManagement.edit.title"/>}/>
        <div className="campaign-detail-notifications">
          <Messages/>
          <Messages notificationId={ NOTIFICATION_ORDER_ACTIONS }/>
        </div>
        <PageSurface className="campaign-detail-edit-surface">
          {
            hasCampaignsEditAccess() ? <EditCampaignForm
              setCouponCreated={ setCouponCreated }
              setParentCampaign={ setCampaign }
            /> : <NoRights/>
          }
        </PageSurface>
        <PageSurface
          className="campaign-detail-coupon-surface"
          header={(
            <div className="campaign-detail-coupon-header">
              <h2 className="campaign-detail-section-title">
                <FormattedMessage id="components.pages.campaignManagement.createCampaignForm.couponList"/>
              </h2>
              <div className="campaign-detail-coupon-actions">
                {
                  hasCouponListAccess() ?
                    <AddCouponInCampaign
                      campaign={ campaign }
                      setCouponCreated={ setCouponCreated }
                    /> : null
                }
              </div>
            </div>
          )}
        >
          <div className="campaign-detail-coupon-notifications">
            <Messages />
            <Messages notificationId={ NOTIFICATION_CREATE_COUPON } hideFieldsErrors={ true } />
          </div>
          {
            hasCouponCreateAccess() ?
              <CouponTable
                couponCreated={ couponCreated }
                setCouponCreated={ setCouponCreated }
              /> : <NoRights/>
          }
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

const mapActionsToProps = {
  hideNotification,
};

const EditCampaign = connect(null, mapActionsToProps)(EditCampaignComponent);

export { EditCampaign, EditCampaignComponent };
